function Click(handler) {

    this.name = 'click';

    this.handler = handler;
}

export {Click};
